<template>
  <SelectSingleInput
    v-model="model"
    :items="items"
    item-text="reasonText"
    item-value="reasonCd"
    :label="label"
    :disabled="disabledComputed"
    :loading="loading"
    :required="requiredComputed"
    @change="onChange"
  />
</template>

<script>
import SelectSingleInput from '@/components/atoms/base/select/SelectSingleInput'
import { API } from '@/plugins/api'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'

export default {
  name: 'MmmmReasonInput',

  mixins: [APIUtils, Message],

  components: { SelectSingleInput },

  props: {
    value: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: false,
      default: function () {
        return this.$t('ELE0446')
      },
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    required: {
      type: Boolean,
      default: false,
      required: false,
    },
    validOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
    applCatCd: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      items: [],
      loading: false,
    }
  },

  watch: {
    applCatCd: {
      async handler() {
        await this.setReason()
      },
      immediate: true,
    },
  },

  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value ? value : '')
      },
    },
    requiredComputed() {
      let required = this.required
      if (this.items.length == 0) {
        required = false
      }
      return required
    },
    disabledComputed() {
      let disabled = this.disabled
      if (this.items.length == 0) {
        disabled = true
      }
      return disabled
    },
  },

  methods: {
    onChange(value) {
      this.$emit('change', value)
    },

    async setReason() {
      this.loading = true
      try {
        this.items = []
        if (this.applCatCd) {
          let params = {
            applCatCd: this.applCatCd,
            validOnly: this.validOnly,
          }

          const elements = await API.get('/master/mmmm/reasons', params)
          elements.forEach((element) => {
            element['reasonText'] = element['reasonName']
            this.items.push(element)
          })
        }
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0446') })))
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
